import _ from 'lodash';
import React, { useEffect } from 'react';

import ActionInput from 'app/developer-v3/pages/actions/ActionInput';
import { FIELD_KEYS } from 'app/developer-v3/constants';
import type { ErrorList } from 'app/developer-v3/types/validator';
import type { StaticDropdown } from 'app/developer-v3/platformSchema/field';
import type { TriggerSchema } from 'app/developer-v3/platformSchema/trigger';
import type {
  ActionInputParams,
  FormFieldTemplate,
  FormifiedFieldSchema,
  ActionSchema,
  DropdownType,
} from 'app/developer-v3/types';

const OPTION_FIELDS_TO_OMIT = [FIELD_KEYS.list, FIELD_KEYS.altersDynamicFields];
const shouldOmit = _.partial(_.includes, OPTION_FIELDS_TO_OMIT);
// @ts-ignore
const rejectFields = _.partial(_.reject, _, ({ key }) => shouldOmit(key));
const filterFields = formFields =>
  formFields.map(formField =>
    formField.key === FIELD_KEYS.options
      ? { ...formField, fields: rejectFields(formField.fields) }
      : formField
  );

type Props = {
  action: ActionSchema;
  attemptedSave: boolean;
  errors: ErrorList;
  formFields: FormFieldTemplate[];
  formifiedField: FormifiedFieldSchema;
  isFormValid: boolean;
  onFormChange: (formValues: FormifiedFieldSchema) => void;
  setInputField: () => void;
  resetInputField: () => void;
  params: ActionInputParams;
  searches: ActionSchema[];
  setDropdown: (type: DropdownType, dropdown: string | StaticDropdown) => void;
  setSearch: (type: DropdownType, searchRef: string) => void;
  toggleDropdown: (isDropdownEnabled: boolean) => void;
  toggleSearch: (isDropdownEnabled: boolean) => void;
  availableTriggers: TriggerSchema[];
};

const ActionGroupChildInputEditor = (props: Props) => {
  const {
    formFields,
    formifiedField,
    onFormChange,
    resetInputField,
    setInputField,
  } = props;

  useEffect(() => {
    setInputField();
    return () => resetInputField();
  }, [resetInputField, setInputField]);

  return (
    <ActionInput
      {...props}
      formFields={filterFields(formFields)}
      onBlur={({ field }) => {
        onFormChange({ ...formifiedField, [field.key]: field.value.trim() });
      }}
      onFormChange={onFormChange}
    />
  );
};

export default ActionGroupChildInputEditor;
